namespace Solovis.Reports.TableFilters {


    export class BoolFilterControl extends Solovis.UI.BaseControl {
        private _initialState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByBoolMatch;        
        private _onStateChangedHandler: () => void;

        private _yesCheckBox: DevExpress.ui.dxCheckBox;
        private _noCheckBox: DevExpress.ui.dxCheckBox;
        private _notSetCheckBox: DevExpress.ui.dxCheckBox;

        constructor(options) {
            super(options);

            this._initialState = options.initialState;            
            this._onStateChangedHandler = options.onStateChanged;            
        }

        public doInit() {
        }

        public doRender() {
            let self = this;

            let yesDiv = $("<div>").appendTo(this.container);
            $(yesDiv).dxCheckBox({
                text: "Yes",
                value: !!(!this._initialState || this._initialState.yes),
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._yesCheckBox = $(yesDiv).dxCheckBox("instance");

            let noDiv = $("<div>").appendTo(this.container).css("padding-left", "15px");
            $(noDiv).dxCheckBox({
                text: "No",
                value: !!(!this._initialState || this._initialState.no),
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._noCheckBox = $(noDiv).dxCheckBox("instance");

            let notSetDiv = $("<div>").appendTo(this.container).css("padding-left", "15px");
            $(notSetDiv).dxCheckBox({
                text: "Not Set",
                value: !!(!this._initialState || this._initialState.notSet),
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._notSetCheckBox = $(notSetDiv).dxCheckBox("instance");
        }

        public getCurrentState(): Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByBoolMatch {
            if (this._yesCheckBox) {
                let newState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByBoolMatch = {
                    yes: this._yesCheckBox.option("value"),
                    no: this._noCheckBox.option("value"),
                    notSet: this._notSetCheckBox.option("value")
                };

                return newState;
            }
            else {
                return this._initialState;
            }
        }
        
    }

}